import React from 'react';

import CommonBanner from './CommonGoogleAdBanner';

const ArticlesBannerC = ({ data }) => {
  return <CommonBanner data={data} typePosition="articles_banner_c" />;
};

export default ArticlesBannerC;
